import React, { useContext, useState } from 'react'
import { Button, Container, Inline, Modal } from '@airbus/components-react/components'
import { useTranslation } from 'react-i18next'
import PageHeader from 'components/pageHeader'
import useMutation from 'utils/hooks/useMutation'
import URL_APIS from 'utils/api/urlApis'
import { InstallationRemovalInput } from 'types/workorder/installationRemoval'
import { Lang } from 'context/LangContext'
import LightDarkContext from 'context/LightDarkModeContext'

type Props = {
  lang: Lang
  open: boolean
  resource: InstallationRemovalInput
  onClose: () => null
  oenumdoc1: string
  oenumdoc2: string
}

const styleModal = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  border: '2px solid #000',
  boxShadow: 24,
  height: '60%',
  width: '60%',
  overflow: 'hidden',
}

const ModalInstallationRemoval = ({ lang, open, resource, onClose, oenumdoc1, oenumdoc2 }: Props) => {
  const { t } = useTranslation()
  const [isLoading, setIsLoading] = useState(false)

  const { mutate: editInstallationRemoval } = useMutation<InstallationRemovalInput>(
    URL_APIS.URL_WORKORDER_INSTALLATION_REMOVAL_POST,
  )

  const handleSubmit = async (data: InstallationRemovalInput) => {
    const requestData = {
      ...data,
    }

    const response = (
      await editInstallationRemoval({ data: requestData, params: { oenumdoc1, oenumdoc2 }, method: 'POST' })
    ).data
  }

  const { getBackgroundColor } = useContext(LightDarkContext)

  return (
    <>
      <Modal
        open={open}
        onClose={onClose}
        aria-labelledby='modal-modal-title'
        aria-describedby='modal-modal-description'
      >
        <div style={{ ...styleModal, backgroundColor: getBackgroundColor() }}>
          <PageHeader
            lang={lang}
            pageTitle={t('7009088') + '/' + t('7009087')}
            modalEmbedded={true}
            modalOnClose={onClose}
            style={{ top: 0 }}
            localLoading={isLoading}
          />
          <Container style={{ flex: 1 }} fixed>
            <div style={{ padding: 2, height: '78%' }}>Your fields go here</div>
            <Inline
              align='space-around'
              style={{
                padding: '10px',
                position: 'absolute',
                bottom: 0,
                marginTop: '1em',
                width: '100%',
              }}
            >
              <Button onClick={onClose} variant='secondary'>
                {t('8000569')}
              </Button>
              <Button onClick={handleSubmit} variant='primary'>
                {t('9500174')}
              </Button>
            </Inline>
          </Container>
        </div>
      </Modal>
    </>
  )
}

export default ModalInstallationRemoval
